import { createSelector } from 'reselect';
import { getCanonical } from 'store/selectors/application';

export default createSelector(getCanonical('/contact-us'), (canonical) => ({
	canonical,
}));
